import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Markdown`}</h1>
    <p>{`Markdown nació como herramienta de conversión de texto plano a HTML.`}</p>
    <p>{`Es un lenguaje de marcado ligero
creado por John Gruber el año 2004
con una ayuda importante de Aaron Swartz`}</p>
    <p>{`se considera un lenguaje que:`}</p>
    <blockquote>
      <p parentName="blockquote">{`tiene la finalidad de permitir crear contenido de una manera sencilla de escribir,
y que en todo momento mantenga un diseño legible`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      